import React, { Ref } from 'react';
import { ImperativeAPI } from '../types/imperative-api';
import { ImageField } from '../image-components/image-field';
import { useSignatureImageAlt } from './use-signature-image-alt';

type Props = {
  signer: string;
  signatureGuid: string;
  isFormView?: boolean;
  onKeyPress?: (event: React.KeyboardEvent) => void;
  onTouchEnd?: (event: React.TouchEvent) => void;
  onClick?: (event: React.MouseEvent) => void;
  tabIndex?: number;
  'data-qa-ref'?: string;
  'data-testid'?: string;
};
function SignatureImageInternal(
  {
    isFormView,
    signer,
    signatureGuid,
    onKeyPress,
    onTouchEnd,
    onClick,
    tabIndex,
    'data-qa-ref': dataQaRef,
    'data-testid': dataTestId,
  }: Props,
  ref: Ref<ImperativeAPI>,
) {
  const altTextMessage = useSignatureImageAlt({ signer });

  return (
    <ImageField
      isFormView={isFormView}
      alt={altTextMessage}
      id={signatureGuid}
      onKeyPress={onKeyPress}
      onTouchEnd={onTouchEnd}
      onClick={onClick}
      tabIndex={tabIndex}
      data-qa-ref={dataQaRef}
      data-testid={dataTestId}
      ref={ref}
    />
  );
}

export const SignatureImage = React.forwardRef(SignatureImageInternal);
